import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import Label from '@/Controls/Label';

export default class AssociationLabelFactory extends ControlFactory {

    /**
     *  @override
     */
    control: Label;
    private jQueryControl: JQuery;
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');
    protected Label = ComponentManager.getControl<typeof Label>('Label');

    /**
     * @override
     */
    public viewModel: LabelViewModel;
    
    public constructor(params: any) {
        super(params);
        this.isFocusable(false);
    }

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.viewModel = new this.LabelViewModel({
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            invalidationText: this.invalidationText,
            isValid: this.isValid,
            placeholder: '-',
            caption: this.context?.genericObject.getObservable(this.detailViewItem.name + '.ObjectIdentValue'),
            parentLocator: this.locator,
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            }),
            locator: this.detailViewItem.name
        });

        this.control = new this.Label(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        this.registerDefaultValidation([this.detailViewItem.name + '.ObjectIdentValue']);

        return this.jQueryControl;
    }
}

ComponentManager.setFactory('AssociationLabel', AssociationLabelFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setFactory('AssoziationLabel', AssociationLabelFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');